import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const XPost = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12687"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12687)">
          <rect
            x="-23"
            y="-2"
            width="151"
            height="115"
            rx="4.87097"
            fill="#FEF2F2"
          />
          <path
            d="M60.9924 74.0015H35.4543L20.861 84.9465V74.0015H13.5643C11.6186 74.0015 9.91602 72.2991 9.91602 70.3531V33.87C9.91602 31.9242 11.6186 30.2217 13.5643 30.2217H60.9924C62.9384 30.2217 64.6408 31.9242 64.6408 33.87V70.3531C64.6408 72.2991 62.9384 74.0015 60.9924 74.0015Z"
            fill="white"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="15.3586"
            y="52.7131"
            width="46.8831"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="15.3586"
            y="57.584"
            width="37.1411"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="15.3586"
            y="62.4551"
            width="26.1815"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <circle
            cx="17.7941"
            cy="38.7092"
            r="2.43548"
            fill="#1E1E1E"
          />
          <rect
            x="22.665"
            y="37.4915"
            width="23.1371"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="48.2378"
            y="37.4915"
            width="12.1774"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <path
            d="M48.4525 80.8622H67.0037L77.6046 88.8127V80.8622H82.905C84.3184 80.8622 85.5552 79.6255 85.5552 78.2119V51.71C85.5552 50.2966 84.3184 49.0598 82.905 49.0598H48.4525C47.0389 49.0598 45.8022 50.2966 45.8022 51.71V78.2119C45.8022 79.6255 47.0389 80.8622 48.4525 80.8622Z"
            fill="white"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M63.9772 72.7728C64.6671 73.5191 65.8429 73.5308 66.5476 72.7985L74.2594 64.7841C75.8495 63.194 76.2029 60.7205 75.3195 58.6003C73.7294 55.4201 69.3124 54.7134 66.8389 57.1869L65.4255 58.6003L64.0119 57.1869C61.3618 54.5367 57.1215 55.2434 55.5313 58.6003C54.4714 60.7205 54.8247 63.194 56.5915 64.7841L63.9772 72.7728Z"
            fill="#FF5A4F"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M64.6773 46.0158H9.87891V44.7981H64.6773V46.0158Z"
            fill="black"
          />
          <rect
            x="73.0492"
            y="21.5453"
            width="31.9657"
            height="31.9657"
            rx="15.9829"
            fill="white"
          />
          <rect
            x="73.0492"
            y="21.5453"
            width="31.9657"
            height="31.9657"
            rx="15.9829"
            stroke="#1E1E1E"
            strokeWidth="0.913306"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M95.3392 30.462C95.3961 30.5149 95.4419 30.5784 95.4741 30.6491C95.5064 30.7197 95.5244 30.796 95.5271 30.8736C95.5299 30.9511 95.5173 31.0285 95.4901 31.1012C95.463 31.174 95.4217 31.2406 95.3688 31.2974L90.5618 36.4523L95.8674 43.495C95.9334 43.5827 95.9736 43.6871 95.9836 43.7964C95.9936 43.9057 95.9729 44.0157 95.9239 44.1139C95.8748 44.2121 95.7994 44.2947 95.7061 44.3525C95.6127 44.4102 95.5051 44.4408 95.3954 44.4409H92.1588C92.0673 44.4409 91.977 44.4197 91.8951 44.3789C91.8132 44.3381 91.7418 44.2788 91.6868 44.2057L87.9527 39.2505L83.2888 44.253C83.1819 44.3676 83.0339 44.4351 82.8773 44.4406C82.7206 44.4461 82.5683 44.3891 82.4536 44.2822C82.339 44.1754 82.2715 44.0273 82.2661 43.8707C82.2606 43.7141 82.3175 43.5617 82.4244 43.4471L87.2313 38.2922L81.9257 31.2495C81.8598 31.1618 81.8196 31.0575 81.8096 30.9482C81.7996 30.839 81.8202 30.7291 81.8692 30.6309C81.9181 30.5327 81.9934 30.45 82.0867 30.3922C82.18 30.3344 82.2875 30.3038 82.3972 30.3036H85.6343C85.7258 30.3037 85.8159 30.3249 85.8977 30.3657C85.9796 30.4065 86.0508 30.4658 86.1058 30.5388L89.8398 35.494L94.5032 30.4915C94.5561 30.4347 94.6197 30.3888 94.6903 30.3566C94.7609 30.3243 94.8372 30.3063 94.9148 30.3036C94.9924 30.3008 95.0698 30.3134 95.1425 30.3406C95.2152 30.3678 95.2825 30.409 95.3392 30.462ZM89.3424 36.798C89.3257 36.7787 89.3103 36.7584 89.2963 36.7371L85.3395 31.4847H83.5818L92.4531 43.2598H94.2108L89.3424 36.798Z"
            fill="black"
          />
        </g>
      </SvgIcon>
    );
  })
);
